import { useState, useEffect } from 'react';
import { Nav, Spinner, Button } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { useApi } from '../../contexts/ApiProvider';

import HobbyBlueprint from './tabs/HobbyBlueprint';
import HobbyInventory from './tabs/HobbyInventory';
import HobbyProjects from './tabs/HobbyProjects';

export default function HobbyDetailContainer() {
    const { id } = useParams();
    const api = useApi();
    const navigate = useNavigate();

    const [hobby, setHobby] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('projects');

    useEffect(() => {
        fetchHobbyDetails();
        // eslint-disable-next-line
    }, [id]);

    const fetchHobbyDetails = async () => {
        setIsLoading(true);
        const res = await api.get('/hobbies?per_page=100');
        if (res.ok) {
            const currentHobby = res.body.items.find(h => h.id === parseInt(id));
            setHobby(currentHobby);
        }
        setIsLoading(false);
    };

    if (isLoading) {
        return <div className="text-center py-5 mt-5"><Spinner animation="border" variant="primary" /></div>;
    }

    if (!hobby) {
        return (
            <div className="py-5 text-center fade-in">
                <h3 className="text-muted">Hobby not found.</h3>
                <Button variant="link" onClick={() => navigate('/hobbies')}>Return to Dashboard</Button>
            </div>
        );
    }

    return (
        <div className="fade-in">
            <Button variant="link" className="text-muted p-0 mb-3 text-decoration-none" onClick={() => navigate('/hobbies')}>
                <i className="bi bi-arrow-left me-2"></i>Back to Hobbies
            </Button>
            <div className="mb-4">
                <h2 className="fw-bold mb-1">{hobby.name}</h2>
                <p className="text-muted">{hobby.description}</p>
            </div>

            <Nav variant="pills" className="mb-4 bg-light p-2 rounded-pill d-inline-flex overflow-auto w-100 flex-nowrap hide-scrollbar">
                <Nav.Item>
                    <Nav.Link
                        className={`rounded-pill px-4 fw-bold text-nowrap ${activeTab === 'projects' ? 'active' : 'text-dark'}`}
                        onClick={() => setActiveTab('projects')}
                        style={{ cursor: 'pointer' }}
                    >
                        Active Projects
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link
                        className={`rounded-pill px-4 fw-bold text-nowrap ${activeTab === 'inventory' ? 'active' : 'text-dark'}`}
                        onClick={() => setActiveTab('inventory')}
                        style={{ cursor: 'pointer' }}
                    >
                        Inventory & Tools
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link
                        className={`rounded-pill px-4 fw-bold text-nowrap ${activeTab === 'blueprint' ? 'active' : 'text-dark'}`}
                        onClick={() => setActiveTab('blueprint')}
                        style={{ cursor: 'pointer' }}
                    >
                        <i className="bi bi-gear-fill me-2"></i>Blueprint
                    </Nav.Link>
                </Nav.Item>
            </Nav>

            <div className="bg-white mt-4">
                {activeTab === 'projects' && (
                    <HobbyProjects hobbyId={hobby.id} />
                )}
                {activeTab === 'inventory' && (
                    <HobbyInventory hobbyId={hobby.id} />
                )}
                {activeTab === 'blueprint' && (
                    <HobbyBlueprint hobbyId={hobby.id} />
                )}
            </div>
        </div>
    );
}
